import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Grid, Navigation, Pagination } from "swiper";
import { storeEatData } from "../data/store_eat.js";
import { storeLiveData } from "../data/store_live.js";
import { storePlayData } from "../data/store_play.js";
import { storeBuyData } from "../data/store_buy.js";
import StoreLabel from "../images/store_label.svg";
import StoreArrow from "../images/store_arrow.svg";
import StoreMapLand from "../images/store_map_land.svg";
import { textLengthFiltered, shuffleData } from "../utils/common";

const Store = () => {
    const lists = [
        { id: "store_eat", type: "#潮好吃", data: storeEatData },
        { id: "store_live", type: "#潮好住", data: storeLiveData },
        { id: "store_play", type: "#潮好玩", data: storePlayData },
        { id: "store_buy", type: "#潮好買", data: storeBuyData }
    ];
    const [activeType, setActiveType] = useState(lists[0].id);
    const screenWidth = useRef(window.innerWidth).current;
    const swiperOptions = {
        slidesPerView: screenWidth > 767 ? 3 : 2.24,
        slidesPerGroup: screenWidth > 767 ? 1 : 1,
        spaceBetween: screenWidth > 767 ? 20 : 15,
        navigation: screenWidth > 767 ? true : false,
        centeredSlides: screenWidth > 767 ? false : true,
        pagination: screenWidth > 767 ? { clickable: true } : false
    };

    return (
        <section
            id="store"
            className="store"
            data-aos="fade-in"
            data-aos-easing="linear"
            data-aos-duration="1000"
        >
            <h2 className="title">
                潮Way台南全區踩點潛力特色店家
            </h2>
            {
                screenWidth > 767 ?
                    <p className="description">
                        精選創作者推薦大公開！<br />
                        絕對不能錯過的40間潛力特色店家，通通一起蒐入口袋名單！
                    </p>
                    :
                    <p className="description">
                        精選創作者推薦大公開！<br />
                        絕對不能錯過的40間潛力特色店家，<br />
                        通通一起蒐入口袋名單！
                    </p>
            }
            <ul
                className="tab"
                data-aos="fade-in"
                data-aos-easing="linear"
                data-aos-duration="1000"
                data-aos-delay="500"
            >
                {
                    lists && lists.map((list) => (
                        <li
                            key={list.id}
                            className={`${activeType === list.id ? "active" : ""}`}
                            onClick={(e) => {
                                setActiveType(list.id);
                            }}
                            data-label={`Sheet${list.id}_click`}
                        >
                            {list.type}
                        </li>
                    ))
                }
            </ul>
            <div className="content">
                <div className="label">
                    <img src={StoreLabel} alt="store-label" />
                </div>
                <div
                    className="store-slider container"
                    data-aos="fade-in"
                    data-aos-easing="linear"
                    data-aos-duration="1000"
                    data-aos-delay="500"
                >
                    <Swiper
                        modules={[Autoplay, Grid, Navigation, Pagination]}
                        slidesPerView={swiperOptions.slidesPerView}
                        slidesPerGroup={swiperOptions.slidesPerGroup}
                        spaceBetween={swiperOptions.spaceBetween}
                        navigation={swiperOptions.navigation}
                        pagination={swiperOptions.pagination}
                        autoplay={{ delay: 5000 }}
                        centeredSlides={swiperOptions.centeredSlides}
                        grid={{
                            rows: 2,
                            fill: "row"
                        }}
                    >
                        {
                            lists.map((list) => (
                                list.id === activeType && list.data && shuffleData(list.data).map((item, i) => (
                                    <SwiperSlide key={`${list.id}_${item.id}_${i}`} className="item">
                                        <a href={item.link || "#"} target="_blank" rel="noreferrer">
                                            <div className="store-img">
                                                <img loading="lazy" src={item.image} alt={item.name} />
                                            </div>
                                            <div className="store-content">
                                                <h3>{item.area}</h3>
                                                <p>{textLengthFiltered(item.name, 10)}</p>
                                            </div>
                                        </a>
                                    </SwiperSlide>
                                ))
                            ))
                        }
                    </Swiper>
                </div>
            </div>
            <div className="arrow">
                <img src={StoreArrow} alt="store-arrow" />
            </div>
            <h2 className="title map-title">
                潛力特色店家大集合
            </h2>
            <p className="description">
                快來領取觀光地圖，輕鬆暢遊台南way！
            </p>
            <div className="map">
                <div className="map-img">
                    <img src={StoreMapLand} width={691} height={602} alt="store-map" />
                    <div className="map-element spa"></div>
                    <div className="map-element dumpling"></div>
                    <div className="map-element cave"></div>
                    <div className="map-element train"></div>
                    <div className="map-element temple"></div>
                    <div className="map-element blueHouse"></div>
                    <div className="map-element castle"></div>
                    <div className="map-element toast"></div>
                    <div className="map-element coffee"></div>
                    <div className="map-element soup"></div>
                    <div className="map-element brownHouse"></div>
                    <div className="map-element bike"></div>
                </div>
            </div>
        </section >
    );
};

export default Store;
